var forms = {

    settings: {
        required: $('form'),
        form_inputs: '.gfield--type-address input, .gfield--type-address select, .gfield--type-email input, .gfield--type-name input, .gfield--type-phone input, .gfield--type-select select, .gfield--type-text input, .gfield--type-textarea textarea',
        spinner_retargeted: false,
    },

    init: function () {
        // General form functions
        if (this.settings.required.length) {
            forms.bindUIActions();
            forms.initializeLabels();
            forms.retargetSpinner();
        }
    },

    bindUIActions: function () {
        // Activate rows on click (delegated so AJAX-rendered inputs are included)
        $(document).on('focusin focusout input', this.settings.form_inputs, forms.toggleLabels);

        // Re-check values after Gravity Forms re-renders a form via AJAX
        $(document).on('gform_post_render', function () {
            forms.initializeLabels();
            forms.retargetSpinner();
        });
    },

    // Move the Gravity Forms submission spinner inside the button, next to its label
    retargetSpinner: function () {
        // The reCAPTCHA add-on defines a bare window.gform on every page, so
        // check for the Gravity Forms hooks API rather than just gform itself
        if (forms.settings.spinner_retargeted || typeof gform === 'undefined' || typeof gform.addFilter !== 'function') {
            return;
        }
        forms.settings.spinner_retargeted = true;

        // Gravity Forms inserts the spinner after this element, so target the
        // label span the button markup filter adds (see includes/plugins.php)
        gform.addFilter('gform_spinner_target_elem', function ($target) {
            var $label = $target.find('.gform_button__label');
            return $label.length ? $label : $target;
        });
    },

    // On page load activate labels that have a value in them
    initializeLabels: function () {
        $(this.settings.form_inputs).each(function () {
            if ($(this).val().length) {
                // Address + Full Name Fields
                if ($(this).closest('.gfield').is('.gfield--type-address, .gfield--type-name')) {
                    $(this).parent().addClass('has-value');
                }
                // All Other Fields
                else {
                    $(this).closest('.gfield').addClass('has-value');
                }
            }
        });
    },

    // Toggle label positioning
    toggleLabels: function(e) {
        // Address + Full Name Fields
        if ($(this).closest('.gfield').is('.gfield--type-address, .gfield--type-name')) {
            if (e.type == 'focusout') {
                $(this).parent().removeClass('active');
                // If a value is present
                if ($(this).val().length) {
                    $(this).parent().addClass('has-value');
                } else {
                    $(this).parent().removeClass('has-value');
                }
            } else {
                $(this).parent().addClass('active');
            }
        }

        // All Other Fields
        else {
            if (e.type == 'focusout') {
                $(this).closest('.gfield').removeClass('active');
                // If a value is present
                if ($(this).val().length) {
                    $(this).closest('.gfield').addClass('has-value');
                } else {
                    $(this).closest('.gfield').removeClass('has-value');
                }
            } else {
                $(this).closest('.gfield').addClass('active');
            }
        }
    },

};
forms.init();
